{
  "certificateCategory": {
    "OTHER_INITIATIVES": "Autre initiative",
    "SCOPE": "Scope",
    "TRANSACTION": "Transaction",
    "UNKNOWN": "Autre"
  },
  "certificateRequestActions": {
    "accept": "Oui",
    "changeToRejected": "Rejeter",
    "question": "Le document fourni correspond-il à la sélection ?",
    "reject": "Non"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Validé",
    "CANCELED": "Annulé",
    "OPENED": "En attente de réception",
    "REJECTED": "Rejeté",
    "SUBMITTED": "À traiter"
  },
  "certificateRequestStatusLifecycle": {
    "ACCEPTED": "Requête validée",
    "SUBMITTED": "Requête en attente"
  },
  "certificateStatus": {
    "NOT_UPLOADED": "En attente de réception",
    "PENDING": "À traiter",
    "PROCESSED": "Enregistré",
    "REJECTED": ""
  },
  "certificateStatusLifecycle": {
    "NOT_UPLOADED": "Document en attente de réception",
    "PENDING": "Document en attente de transcription",
    "PROCESSED": "Document reçu et transcrit",
    "REJECTED": "Document rejeté"
  },
  "filters": {
    "search": {
      "placeholder": "Rechercher"
    },
    "title": "Filtres"
  },
  "lists": {
    "columns": {
      "businessPartner": {
        "header": "Soumis par",
        "tooltip": "Expéditeur du document."
      },
      "category": {
        "header": "Catégorie",
        "OTHER_INITIATIVES": "Autre initiative",
        "SCOPE": "Scope",
        "tooltip": "Scope, Transaction, Autre initiative, Autre.",
        "TRANSACTION": "Transaction",
        "UNKNOWN": "Autre"
      },
      "certificateRequests": {
        "canceled_one": "{{count}} requête de certificat annulée",
        "canceled_many": "{{count}} requêtes de certificats annulées",
        "canceled_other": "{{count}} requêtes de certificats annulées",
        "header": "Requêtes",
        "rejected_one": "{{count}} requête de certificat rejetée",
        "rejected_many": "{{count}} requêtes de certificats rejetées",
        "rejected_other": "{{count}} requêtes de certificats rejetées",
        "submitted_one": "{{count}} requête de certificat soumise",
        "submitted_many": "{{count}} requêtes de certificats soumises",
        "submitted_other": "{{count}} requêtes de certificats soumises",
        "tooltip": "Requêtes de certificat associées à ce document.",
        "validated_one": "{{count}} requête de certificat validée",
        "validated_many": "{{count}} requêtes de certificats validées",
        "validated_other": "{{count}} requêtes de certificats validées"
      },
      "createdAt": {
        "header": "Soumis le",
        "tooltip": "Date de réception du document."
      },
      "expiryDate": {
        "header": "Fin de validité",
        "tooltip": "Date de fin de validité du document."
      },
      "issueDate": {
        "header": "Début de validité",
        "tooltip": "Date de début de validité du document."
      },
      "name": {
        "header": "Nom",
        "tooltip": "Nom ou titre du document."
      },
      "productionSite": {
        "deleted": "Site supprimé",
        "header": "Périmètre (site)",
        "tooltip": "Site associé à ce document."
      },
      "purchaseOrders": {
        "component": {
          "header": "Soumis pour (PO composants)",
          "tooltip": "Soumis pour (PO composants): Liste des numéros des commandes de composants pour lesquelles ce document a été transmis."
        },
        "material": {
          "header": "Soumis pour (PO matériaux)",
          "tooltip": "Soumis pour (PO matériaux): Liste des numéros des commandes de matériaux pour lesquelles ce document a été transmis."
        },
        "product": {
          "header": "Soumis pour (PO produit)",
          "tooltip": "Soumis pour (PO produit): Liste des numéros des commandes de produits finis pour lesquelles ce document a été transmis."
        }
      },
      "reference": {
        "header": "Référence",
        "tooltip": "Code d'identification du document."
      },
      "score": {
        "header": "Note",
        "tooltip": "Cette évaluation reflète le niveau de conformité ou de performance obtenu selon le référentiel du document."
      },
      "status": {
        "header": "Transcription",
        "tooltip": "Statut de traitement du document. Un document doit être transcrit pour être exploité correctement."
      },
      "type": {
        "header": "Sous-catégorie",
        "tooltip": "Type de document."
      }
    },
    "placeholders": {
      "businessPartner": "Soumis par",
      "category": "Catégorie",
      "certificateRequestStatus": "Requêtes",
      "certificateStatus": "Transcription",
      "certificateType": "Sous-catégorie",
      "componentPOs": "Soumis pour (PO composants)",
      "createdAt": "Soumis le",
      "materialPOs": "Soumis pour (PO matériaux)",
      "productionSite": "Périmètre (site)",
      "productPOs": "Soumis pour (PO produits)",
      "score": "Note",
      "search": "Rechercher un certificat...",
      "validFrom": "Valide du",
      "validTo": "Valide au"
    },
    "tabs": {
      "all": "Tous",
      "scope": "Certificats et Audits",
      "transaction": "Preuves de transaction"
    },
    "title": "Documents"
  },
  "modal": {
    "associatedRequests": {
      "card": {
        "description": {
          "common": "Un <type>{{type}}</type> valide le <maxIssueDate>{{maxIssueDate}}</maxIssueDate> pour le site <productionSiteName>{{productionSiteName}}</productionSiteName> propriété de <productionSiteOrganizationName>{{productionSiteOrganizationName}}</productionSiteOrganizationName> a été demandé pour l'étape <activityName>{{activityName}}</activityName>.",
          "component": "Composant: {{componentName}}",
          "material": "Material: {{materialName}}",
          "product": "Référence : <productBrandReference>{{productBrandReference}}</productBrandReference> <productColor>({{productColor}})</productColor>",
          "purchaseOrder": "PO: <purchaseOrder>{{purchaseOrder}}</purchaseOrder>"
        },
        "header": "Le {{createdAt}}"
      },
      "description": "Ce document a été soumis par {{sender}} pour répondre aux requêtes suivantes :",
      "title": "Informations & Requêtes associées"
    },
    "error": "Une erreur est survenue lors de la mise à jour du certificat.",
    "form": {
      "description": {
        "bounded": "Ce <b>{{type}}</b> est valide du <b>{{issueDate}}</b> au <b>{{expiryDate}}</b> pour le site <b>{{productionSiteName}}</b> déclaré par <b>{{productionSiteOrganizationName}}</b><activityName> pour l'opération <b>{{activityName}}</b></activityName>.",
        "open": "Ce <b>{{type}}</b> est valide le ou à partir du <b>{{issueDate}}</b> pour le site <b>{{productionSiteName}}</b> déclaré par <b>{{productionSiteOrganizationName}}</b><activityName> pour l'opération <b>{{activityName}}</b></activityName>."
      },
      "summary": "Résumé"
    },
    "labels": {
      "buyerOfCertifiedProducts": "Acheteur de produits",
      "certificationBody": "Organisme de certification",
      "certifiedOrganizationAddress": "Adresse de l'entreprise",
      "certifiedOrganizationLicenseNumber": "Numéro de licence",
      "certifiedOrganizationName": "Nom de l'entreprise",
      "certifiedWeight": "Poids certifié",
      "expiryDate": "Date d'expiration",
      "issueDate": "Date d'émission",
      "linkedScopeCertificateNumber": "Numéro du Scope Certificat lié",
      "manualCheck": "Valider la référence de ce document sur le moteur de recherche Oeko-Tex.",
      "name": "Nom",
      "processingSteps": "Étapes de traitement",
      "productCategories": "Catégories de produits",
      "productDetails": "Détails du produit",
      "reference": "Référence",
      "rejectionMessage": "Message au fournisseur",
      "score": "Note",
      "scoreOptions": {
        "bepi": {
          "advanced": "AMFORI BEPI - Advancé",
          "beginner": "AMFORI BEPI - Débutant",
          "insufficient": "AMFORI BEPI - Insuffisant",
          "leader": "AMFORI BEPI - Leader",
          "other": "AMFORI BEPI - Autre",
          "progressing": "AMFORI BEPI - En progression"
        },
        "bsci": {
          "a": "AMFORI BSCI - A (Excellent)",
          "b": "AMFORI BSCI - B (Bon)",
          "c": "AMFORI BSCI - C (Acceptable)",
          "d": "AMFORI BSCI - D (Insuffisant)",
          "e": "AMFORI BSCI - E (Inacceptable)",
          "other": "AMFORI BSCI - Autre"
        },
        "gots": {
          "certified": "GOTS - Certifié",
          "inConversion": "GOTS - En conversion",
          "other": "GOTS - Autre",
          "suspended": "GOTS - Suspendu",
          "withdrawn": "GOTS - Retiré"
        },
        "grs": {
          "certified": "GRS - Certifié",
          "inConversion": "GRS - En conversion",
          "other": "GRS - Autre",
          "suspended": "GRS - Suspendu",
          "withdrawn": "GRS - Retiré"
        },
        "higgFem": {
          "beginner": "Higg FEM - Débutant",
          "developing": "Higg FEM - En développement",
          "established": "Higg FEM - Établi",
          "leading": "Higg FEM - Leader",
          "other": "Higg FEM - Autre"
        },
        "ics": {
          "a": "ICS - A (Excellent)",
          "b": "ICS - B (Bon)",
          "c": "ICS - C (Acceptable)",
          "d": "ICS - D (Insuffisant)",
          "e": "ICS - E (Inacceptable)",
          "other": "ICS - Autre"
        },
        "iso14001": {
          "certified": "ISO 14001 - Certifié",
          "notCertified": "ISO 14001 - Non certifié",
          "other": "ISO 14001 - Autre",
          "suspended": "ISO 14001 - Suspendu",
          "withdrawn": "ISO 14001 - Retiré"
        },
        "iso45001": {
          "certified": "ISO 45001 - Certifié",
          "notCertified": "ISO 45001 - Non certifié",
          "other": "ISO 45001 - Autre",
          "suspended": "ISO 45001 - Suspendu",
          "withdrawn": "ISO 45001 - Retiré"
        },
        "lwg": {
          "audited": "Leather Working Group - Audité (non classé)",
          "bronze": "Leather Working Group - Bronze",
          "certified": "Leather Working Group - Certifié (membre approuvé)",
          "gold": "Leather Working Group - Or",
          "other": "Leather Working Group - Autre",
          "platinum": "Leather Working Group - Platine",
          "silver": "Leather Working Group - Argent"
        },
        "notApplicable": "Non applicable",
        "oekotex": {
          "ecoPassport": "OEKO-TEX - Eco Passport",
          "leatherStandard": "OEKO-TEX - Leather Standard",
          "madeInGreen": "OEKO-TEX Made in Green",
          "other": "OEKO-TEX - Other",
          "standard100": "OEKO-TEX Standard 100",
          "stepLevel1": "OEKO-TEX Step Level 1",
          "stepLevel2": "OEKO-TEX Step Level 2",
          "stepLevel3": "OEKO-TEX Step Level 3"
        },
        "other": "Autre",
        "rcs": {
          "certified": "RCS - Certifié",
          "inConversion": "RCS - En conversion",
          "other": "RCS - Autre",
          "suspended": "RCS - Suspendu",
          "withdrawn": "RCS - Retiré"
        },
        "sa8000": {
          "compliant": "SA8000 - Comforme",
          "nonCompliant": "SA8000 - Non conforme",
          "other": "SA8000 - Autre",
          "partlyMajor": "SA8000 - Partiellement conforme (problème majeur)",
          "partlyMinor": "SA8000 - Partiellement conforme (problème mineur)"
        },
        "smeta": {
          "criticalNonCompliance": "SMETA - Critical non-compliance",
          "fourPillar": "SMETA - 4-Pillar Audit",
          "majorNonCompliance": "SMETA - Major non-compliance",
          "minorNonCompliance": "SMETA - Minor non-compliance",
          "noNonCompliance": "SMETA - No non-compliance",
          "other": "SMETA - Other",
          "twoPillar": "SMETA - 2-Pillar Audit"
        },
        "wrap": {
          "bronze": "WRAP - Bronze",
          "certified": "WRAP - Certifié",
          "gold": "WRAP - Or",
          "other": "WRAP - Autre",
          "platinum": "WRAP - Platine",
          "silver": "WRAP - Argent"
        }
      },
      "scoreTooltip": "Note ou niveau associé au certificat fourni. Cela reflète le niveau de conformité ou de performance atteint selon les normes du certificat.",
      "status": "Statut",
      "type": "Type"
    },
    "placeholders": {
      "buyerOfCertifiedProducts": "Acheteur de produits certifiés",
      "certificationBody": "Organisme de certification",
      "certifiedOrganizationAddress": "Adresse de l'entreprise certifiée",
      "certifiedOrganizationLicenseNumber": "Numéro de licence de l'entreprise",
      "certifiedOrganizationName": "Nom de l'entreprise certifiée",
      "certifiedWeight": "Poids certifié",
      "expiryDate": "Sélectionnez une date d'expiration",
      "issueDate": "Sélectionnez une date de délivrance",
      "linkedScopeCertificateNumber": "Numéro de certificat de portée lié",
      "name": "Entrez le nom",
      "processingSteps": "Étapes de traitement",
      "productCategories": "Catégories de produits",
      "productDetails": "Détails du produit",
      "reference": "Référence du certificat",
      "rejectionMessage": "Le document téléchargé est expiré, illisible, etc.",
      "score": "Indiquez la note",
      "status": "Statut",
      "type": "Sélectionnez un type de certificat"
    },
    "rejectModal": {
      "submit": "Rejeter",
      "subtitle": "Êtes-vous sûr de vouloir rejeter ce certificat ?",
      "title": "Rejeter le certificat"
    },
    "rejectToolTips": "Veuillez noter : Un e-mail sera envoyé au fournisseur avec votre raison de rejet du certificat. Cela les informera et aidera à garantir que le problème soit traité rapidement.",
    "submit": "Sauvegarder",
    "success": "Certificat validé avec succès !",
    "successAccept": "Le certificat a été validé avec succès.",
    "successReject": "Le certificat a été rejeté et un email a été envoyé au fournisseur.",
    "summary": {
      "tab": {
        "title": "Document & Informations"
      }
    }
  },
  "sorts": {
    "category": "Catégorie",
    "createdAt": "Soumis le",
    "documentStatus": "Transcription",
    "expiryDate": "Valid à",
    "issueDate": "Valid de",
    "name": "Nom",
    "productionSite": "Périmètre (site)",
    "reference": "Référence",
    "score": "Note",
    "totalRequests": "Requêtes totales"
  },
  "standard": {
    "badge": {
      "compliant": "Conforme",
      "notCompliant": "Non conforme"
    },
    "drawer": {
      "certificatesNumber_one": "{{completedCertificates}}/{{totalCertificates}} document attendu",
      "certificatesNumber_many": "certificatesNumber",
      "certificatesNumber_other": "{{completedCertificates}}/{{totalCertificates}} documents attendus",
      "complianceRules": "Règles de conformité",
      "complianceRulesAllCompliant": "Les {{totalRules}} règles de conformité sont satisfaites.",
      "complianceRulesPartial": "{{compliantRules}} règles de conformité sur {{totalRules}} sont satisfaites. Certains champs des documents collectés ne respectent pas les règles de ce standard.",
      "reviewCertificate": "Ouvrir le certificat pour vérification",
      "rules": {
        "certificationBody": {
          "description": {
            "failure": "Au moins un document collecté provient d'un organisme de certification différent des autres documents appliqués à la même étape de production.",
            "success": "Les documents collectés pour la même étape de production ont été émis par le même organisme de certification."
          },
          "title": "Organismes de certification"
        },
        "certifiedEntity": {
          "description": {
            "failure": "Au moins un document collecté concerne un lieu de production certifié différent des autres documents appliqués à la même étape de production.",
            "success": "Les documents collectés pour la même étape de production concernent le même lieu de production."
          },
          "title": "Lieux de production certifiés"
        },
        "productCategories": {
          "description": {
            "failure": "Au moins un document collecté ne couvre pas la même catégorie que les autres documents appliqués à la même étape de production.",
            "success": "Les documents collectés pour la même étape de production couvrent les mêmes catégories."
          },
          "title": "Catégories"
        },
        "relevantStandard": {
          "description": {
            "failure": "Au moins un document collecté ne se rapporte pas au bon standard.",
            "success": "Les documents collectés pour la même étape de production se rapportent au bon standard."
          },
          "title": "Standards pertinents"
        },
        "validityPeriod": {
          "description": {
            "failure": "Au moins un document collecté n'est pas valide pendant la même période que les autres documents appliqués à la même étape de production.",
            "success": "Les documents collectés pour la même étape de production sont valides pendant la même période."
          },
          "title": "Périodes de validité"
        }
      },
      "segmentBadgeTooltipNotUploaded_one": "Ce document attendu n'a pas encore été reçu.",
      "segmentBadgeTooltipNotUploaded_many": "Ces documents attendus n'ont pas encore été reçus.",
      "segmentBadgeTooltipNotUploaded_other": "{{count}} documents attendus n'ont pas encore été reçus.",
      "segmentBadgeTooltipPendingReview_one": "Ce document reçu est en attente de vérification.",
      "segmentBadgeTooltipPendingReview_many": "Ces documents reçus sont en attente de vérification.",
      "segmentBadgeTooltipPendingReview_other": "{{count}} documents reçus sont en attente de vérification.",
      "segmentBadgeTooltipValidated_one": "Ce document a été validé et est utilisé pour les contrôles de conformité.",
      "segmentBadgeTooltipValidated_many": "Ces documents ont été validés et sont utilisés pour les contrôles de conformité.",
      "segmentBadgeTooltipValidated_other": "Ces documents ont été validés et sont utilisés pour les contrôles de conformité."
    }
  }
}
